export enum GameStatus {
  LOBBY,
  PLAYING_COUNTDOWN,
  PLAYING,
  PLAYING_ROUND_END,
  FINISHED,
}
